module.exports = __webpack_public_path__ + "img/black-panther.8e30b893.svg";